module.exports = __webpack_public_path__ + "img/hero-coming-soon.ea9e8c25.png";